interface IScaleIPLogoProperties {
  height?: number;
  width?: number;
}

const ScaleIPLogo = ({ height = 32, width = 32 }: IScaleIPLogoProperties) => {
  return (
    <svg fill="none" height={height} viewBox="0 0 32 32" width={width} xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M4.92308 0H27.0769C29.7959 0 32 2.20414 32 4.92308V27.0769C32 29.7959 29.7959 32 27.0769 32H4.92308C2.20413 32 0 29.7959 0 27.0769V4.92308C0 2.20413 2.20414 0 4.92308 0ZM4.92308 2.46154C3.56361 2.46154 2.46154 3.56361 2.46154 4.92308V27.0769C2.46154 28.4364 3.56361 29.5385 4.92308 29.5385H27.0769C28.4364 29.5385 29.5385 28.4364 29.5385 27.0769V4.92308C29.5385 3.56361 28.4364 2.46154 27.0769 2.46154H4.92308Z"
        fill="#00B977"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.4622 16.7657C17.8352 16.1188 18.1746 15.5004 18.4897 14.9238C18.5201 14.8681 18.5503 14.8129 18.5802 14.7581C18.8643 14.238 19.1263 13.7582 19.3845 13.3066C19.9592 12.3017 20.4652 11.5273 21.0163 10.931C21.5483 10.3556 22.1182 9.95143 22.8327 9.6947C23.5628 9.43234 24.5273 9.29423 25.8831 9.3785C26.6972 9.4291 27.3982 8.81015 27.4488 7.99604C27.4994 7.18193 26.8805 6.48095 26.0664 6.43035C24.4328 6.32881 23.0438 6.48008 21.8338 6.91487C20.6082 7.35529 19.6513 8.0561 18.8472 8.92597C18.0623 9.7751 17.423 10.7864 16.8203 11.8403C16.5468 12.3186 16.2706 12.8244 15.9893 13.3395C15.9588 13.3954 15.9282 13.4514 15.8975 13.5075C15.5817 14.0855 15.2547 14.6811 14.898 15.2994C14.8943 15.3059 14.8906 15.3123 14.887 15.3188C14.6347 15.7718 14.401 16.199 14.1788 16.605C13.7405 17.4063 13.3474 18.1248 12.9465 18.7945C12.3524 19.7872 11.8092 20.5525 11.2191 21.1374C10.1428 22.2042 8.74521 22.8438 5.99931 22.6731C5.1852 22.6225 4.48421 23.2415 4.43361 24.0556C4.38301 24.8697 5.00196 25.5707 5.81607 25.6213C9.21125 25.8323 11.4997 25.0182 13.2985 23.2353C14.1459 22.3954 14.8376 21.3868 15.4811 20.3115C15.911 19.5932 16.3504 18.7903 16.8067 17.9566C17.0212 17.5646 17.2395 17.1658 17.4622 16.7657Z"
        fill="#00B977"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ScaleIPLogo;
